<div class="ttmodal" *ngIf="isAddQuestion">
  <div class="ttmodal__header">
    <span class="ttmodal__title">{{'Add Question' | translate | async}}</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div>
  <div class="ttmodal__body">

    <div class="input-container flexInput">
      <span class="label">{{'Question' | translate | async}} <span class="red-text">*</span></span>
      <textarea class="input-text " style="margin: 0px; width: 100%; height: 75px;" [(ngModel)]="QTitle" type="text"
        placeholder="Question" required></textarea>
    </div>

    <div class="input-container flexInput" style="margin-top: 3%;">
      <span class="label"> Select Slide <span class="red-text">*</span></span>
      <mat-form-field class="setup-form-full-width">
        <mat-select placeholder="Select Slide" [(ngModel)]="SlideId">
          <mat-option *ngFor="let slide of SlideList" [value]="slide.SlideId">{{ slide.SlideName }}
          </mat-option>
        </mat-select>
      </mat-form-field>

    </div>

    <div class="input-container flexInput">
      <span class="label"> Question Type <span class="red-text">*</span></span>
      <mat-form-field class="setup-form-full-width">
        <mat-select placeholder="Select Question Type" [(ngModel)]="questionTypeId">
          <mat-option *ngFor="let type of QuestionTypes" [value]="type.Id" (click)="ChangeOption()">{{ type.Title }}
          </mat-option>
        </mat-select>
      </mat-form-field>


    </div>

    <div style="display: flex; flex-direction: row;">
      <div *ngIf="questionTypeId==1">
        <div class="input-container flexInput" style="margin-top: 3%;">
          <span class="label">Correct Answers <span class="red-text"></span></span>
          <mat-radio-group aria-label="Select Slide Type" (change)="SelectAnswerTrueFalse()"
            [(ngModel)]="RadioTrueFalse">
            <mat-radio-button [value]="1">True</mat-radio-button>
            <mat-radio-button [value]="2">False</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>

      <div *ngIf="questionTypeId ==2 ||  questionTypeId==3">

        <span class="label">Answers <span class="red-text"></span></span>
        <div>
          <input class="input-text" [(ngModel)]="Option" type="text" placeholder="Enter Answer">
          <input type="button" value="Add Answer" style="margin-bottom: 16px;" (click)="AddAnswerOption()" />
        </div>
        <ng-container>
          <!-- <div style="    width: 100%;display: flex;flex-direction: row;">
            <span style="vertical-align: top;margin-right: 26%;width: 100%;"><b>Answer Option</b></span>
            <span style="vertical-align: top;margin-right: 4%;width: 100%;"><b>Correct Answer</b></span>
            <span style="vertical-align: top;margin-right: 4%;width: 100%;"><b>Remove Answer</b></span>
          </div> -->
          <div *ngFor="let ans of AnswerOptions" style="    width: 100%;display: flex;flex-direction: row;">
            <span style="vertical-align: top;margin-right: 4%;width: 100%;">{{ans.Name}}</span>
            

            <ng-container *ngIf="questionTypeId==2 ">
              <span *ngIf=" ans.Select==false"
                style="min-width:150px; max-width: 10em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;cursor: pointer;"
                title="Delete Answer Option"><i class="material-icons sc-icon"
                  (click)="selectAnswerRadio(ans.Id)">radio_button_unchecked</i></span>

              <span *ngIf=" ans.Select==true"
                style="color: mediumseagreen;min-width:150px; max-width: 10em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;cursor: pointer;"
                title="Delete Answer Option"><i class="material-icons sc-icon"
                  (click)="selectAnswerRadio(ans.Id)">radio_button_checked</i></span>

            </ng-container>

            <ng-container *ngIf="questionTypeId==3 ">
              <span *ngIf=" ans.Select==false"
                style="min-width:150px; max-width: 10em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; cursor: pointer;"><i class="material-icons sc-icon"
                  (click)="selectAnswer(ans.Id,true)">check_box_outline_blank</i></span>

              <span *ngIf=" ans.Select==true"
                style="color: mediumseagreen;min-width:150px; max-width: 10em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;cursor: pointer;"><i class="material-icons sc-icon"
                  (click)="selectAnswer(ans.Id,false)">check_box</i></span>

                  

            </ng-container>
            <span
            style="min-width:150px;color: red; max-width: 10em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;cursor: pointer;" ><i class="material-icons sc-icon"
              (click)="RemoveAnswerOption(ans.Id)">remove_circle_outline</i></span>




          </div>

          <div class="input-container flexInput"> 
            <span class="label">Correct Answer Count <span class="red-text"></span></span>
            <input class="input-text" style="width: fit-content;" [(ngModel)]="correctAnswerCount" type="number" placeholder="Answer Count" (change)="validateAnswerCount()">
           
          </div>
          <span *ngIf="validateOptions==true" style="vertical-align: top;margin-right: 26%;width: 100%; color: red;">Error:Answer Count Invalid</span>
        </ng-container>

      </div>
    </div>
    <!-- <div style="display: flex; flex-direction: row; margin-top: 3%;">
      <div style="width: 50%;">
        <div style="display: flex;">


          <span class="input-description">Question Image </span>
        </div>

        <input type='file' (change)="onSelectImage($event)">
        <div style="margin-top: 8px;">
          <img *ngIf="imageUrl" [src]="imageUrl" height="auto" width="100%">
        </div>
      </div>



    </div> -->



  </div>

  <div class="ttmodal__footer">
    <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
    <!-- <a class="button button--primary" (click)="onAddQuestion()"><span class="button__text" [disabled]="validateOptions==true">Add Question</span></a> -->
    <button class="button button--primary" [disabled]="validateOptions" (click)="onAddQuestion()" ><span class="button__text">Add Question</span></button>
  </div>
</div>

<div class="ttmodal" *ngIf="isEditQuestion">
  <div class="ttmodal__header">
    <span class="ttmodal__title">Edit Question</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div>
  <div class="ttmodal__body">

    <div class="input-container flexInput">
      <span class="label">Question <span class="red-text">*</span></span>
      <textarea class="input-text " style="margin: 0px; width: 100%; height: 75px;" [(ngModel)]="QTitle" type="text"
        placeholder="Question" required></textarea>
    </div>

    <div class="input-container flexInput" style="margin-top: 3%;">
      <span class="label"> Select Slide <span class="red-text">*</span></span>
      <mat-form-field class="setup-form-full-width">
        <mat-select placeholder="Select Slide" [(ngModel)]="SlideId">
          <mat-option *ngFor="let slide of SlideList" [value]="slide.SlideId">{{ slide.SlideName }}
          </mat-option>
        </mat-select>
      </mat-form-field>

    </div>

    <div class="input-container flexInput">
      <span class="label"> Question Type <span class="red-text">*</span></span>
      <mat-form-field class="setup-form-full-width">
        <mat-select placeholder="Select Question Type" [(ngModel)]="questionTypeId">
          <mat-option *ngFor="let type of QuestionTypes" [value]="type.Id" (click)="ChangeOption()">{{ type.Title }}
          </mat-option>
        </mat-select>
      </mat-form-field>


    </div>

    <div style="display: flex; flex-direction: row;">
      <div *ngIf="questionTypeId==1">
        <div class="input-container flexInput" style="margin-top: 3%;">
          <span class="label">Correct Answers <span class="red-text"></span></span>
          <mat-radio-group aria-label="Select Slide Type" (change)="SelectAnswerTrueFalse()"
            [(ngModel)]="RadioTrueFalse">
            <mat-radio-button [value]="1">True</mat-radio-button>
            <mat-radio-button [value]="2">False</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>

      <div *ngIf="questionTypeId ==2 ||  questionTypeId==3">

        <span class="label">Answers <span class="red-text"></span></span>
        <div>
          <input class="input-text" [(ngModel)]="Option" type="text" placeholder="Enter Answer">
          <input type="button" value="Add Answer" style="margin-bottom: 16px;" (click)="AddAnswerOption()" />
        </div>
        <ng-container>
          <!-- <div style="    width: 100%;display: flex;flex-direction: row;">
            <span style="vertical-align: top;margin-right: 26%;width: 100%;"><b>Answer Option</b></span>
            <span style="vertical-align: top;margin-right: 4%;width: 100%;"><b>Correct Answer</b></span>
            <span style="vertical-align: top;margin-right: 4%;width: 100%;"><b>Remove Answer</b></span>
          </div> -->
          <div *ngFor="let ans of AnswerOptions" style="    width: 100%;display: flex;flex-direction: row;">
            <span style="vertical-align: top;margin-right: 4%;width: 100%;">{{ans.Name}}</span>
            

            <ng-container *ngIf="questionTypeId==2 ">
              <span *ngIf=" ans.Select==false"
                style="min-width:150px; max-width: 10em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;cursor: pointer;"
                title="Delete Answer Option"><i class="material-icons sc-icon"
                  (click)="selectAnswerRadio(ans.Id)">radio_button_unchecked</i></span>

              <span *ngIf=" ans.Select==true"
                style="color: mediumseagreen;min-width:150px; max-width: 10em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;cursor: pointer;"
                title="Delete Answer Option"><i class="material-icons sc-icon"
                  (click)="selectAnswerRadio(ans.Id)">radio_button_checked</i></span>

            </ng-container>

            <ng-container *ngIf="questionTypeId==3 ">
              <span *ngIf=" ans.Select==false"
                style="min-width:150px; max-width: 10em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; cursor: pointer;"><i class="material-icons sc-icon"
                  (click)="selectAnswer(ans.Id,true)">check_box_outline_blank</i></span>

              <span *ngIf=" ans.Select==true"
                style="color: mediumseagreen;min-width:150px; max-width: 10em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;cursor: pointer;"><i class="material-icons sc-icon"
                  (click)="selectAnswer(ans.Id,false)">check_box</i></span>

                  

            </ng-container>
            <span
            style="min-width:150px;color: red; max-width: 10em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;cursor: pointer;" ><i class="material-icons sc-icon"
              (click)="RemoveAnswerOption(ans.Id)">remove_circle_outline</i></span>




          </div>

          <div class="input-container flexInput" *ngIf="questionTypeId==3"> 
            <span class="label">Correct Answer Count <span class="red-text"></span></span>
            <input class="input-text" style="width: fit-content;" [(ngModel)]="correctAnswerCount" type="number" placeholder="Answer Count" (change)="validateAnswerCount()">
           
          </div>
          <span *ngIf="validateOptions==true" style="vertical-align: top;margin-right: 26%;width: 100%; color: red;">Error:Answer Count Invalid</span>
        </ng-container>

      </div>
    </div>
    <!-- <div style="display: flex; flex-direction: row; margin-top: 3%;">
      <div style="width: 50%;">
        <div style="display: flex;">


          <span class="input-description">Question Image </span>
        </div>

        <input type='file' (change)="onSelectImage($event)">
        <div style="margin-top: 8px;">
          <img *ngIf="imageUrl" [src]="imageUrl" height="auto" width="100%">
        </div>
      </div>

    </div> -->



  </div>

  <div class="ttmodal__footer">
    <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
    <!-- <a class="button button--primary" (click)="onAddQuestion()"><span class="button__text" [disabled]="validateOptions==true">Add Question</span></a> -->
    <button class="button button--primary" [disabled]="validateOptions" (click)="onEditQuestion()" ><span class="button__text">Update Question</span></button>
  </div>
</div>